













































































































  import { Component, Vue } from "vue-property-decorator";
  import {
    TitleTemplateDashboard,
    SelectedCountry,
    RedCapital,
  } from "@/configuration";
  import { mapState } from "vuex";
  import API from "@/api";
  import ShowLoading from "@/components/panel/ShowLoading.vue";
  import Step1 from "@/components/alternateLogin/Step1.vue";
  import Step2 from "@/components/alternateLogin/Step2.vue";
  import Step3 from "@/components/alternateLogin/Step3.vue";
	import { EventBus } from "@/main";

  @Component({
    metaInfo: {
      title: "Vincular empresa",
      titleTemplate: TitleTemplateDashboard,
      htmlAttrs: {
        // @ts-ignore
        lang: RedCapital[SelectedCountry].Lang,
      },
    },
    computed: {
      ...mapState(["setOpenMenuPanel"]),
      setOpenMenuPanel(){
        return this.$store.state.openMenuPanel;
      }
    },
    data() {
      return {
        e2: 1,
        valid: false,
        canShow: false, //variable para carga
        step1_complete:false,
        step2_complete:false,
        step3_complete:false,
        f1: false,
        f2:false,
        f3:false,
        show:{
          step:1,
          complete: {
            step1: false,
            step2: false,
            step3: false
          }
        },
        empresa:null,
        data: {
          rut_empresa:null, 
          token: null
        },
        data_enviar:{
          empresa: null,
          usuario_id: null,
          token: null
        },
        isTokenExpired: false
      };
    },
    watch:{
        f1(val) {
          if(val){
            // @ts-ignore
            this.changeStepComplete(this.$data.step1_complete, 'customStep1');
            this.$data.show.complete.step1 = true;
          }else{
            // @ts-ignore
            this.changeStepComplete(this.$data.step1_complete, 'customStep1');
            this.$data.show.complete.step1 = false;
          }
        },
        f2(val) {
          if(val){
            // @ts-ignore
            this.changeStepComplete(this.$data.step2_complete, 'customStep2');
            this.$data.show.complete.step2 = true;
          }else{
            // @ts-ignore
            this.changeStepComplete(this.$data.step2_complete, 'customStep2');
            this.$data.show.complete.step2 = false;
          }
        },
        f3(val) {
          if(val){
            // @ts-ignore
            this.changeStepComplete(this.$data.step3_complete, 'customStep3');
            this.$data.show.complete.step3 = true;
          }else{
            // @ts-ignore
            this.changeStepComplete(this.$data.step3_complete, 'customStep3');
            this.$data.show.complete.step3 = false;
          }
        },
    },
    beforeMount() {
      this.$store.commit("setOpenMenuPanel", false);
      //validacion 
      this.$data.data.rut_empresa = this.$route.query.rut;
      this.$data.data_enviar.token = this.$route.query.token;
      //@ts-ignore
      this.isLoginValid();
      //@ts-ignore
      this.loadInfoCompany();
    },
    methods: {
        nextStep (n) {
            //@ts-ignore
            this.verificarPasoCompletado(n);

            this.$data.e2 = n + 1;
            //@ts-ignore
            this.scrollToCurrentStep();
        },
        verificarPasoCompletado(step){
            
            switch (step){
              case 1:
                this.$data.f1 = true;
                this.$data.step1_complete = true;
                break;
              case 2:
                this.$data.f2 = true;
                this.$data.step2_complete = true;
                break;
              case 3:
                this.$data.f3 = true;
                this.$data.step3_complete = true;
                break
            }

        },
        changeStepComplete(isStepComplete, classStep) {
            const iconMap = {
                'customStep1': isStepComplete ? '<i aria-hidden="true" class="v-icon material-icons theme--light">check</i>' : '<i aria-hidden="true" class="v-icon material-icons-outlined theme--light">business</i>',
                'customStep2': isStepComplete ? '<i aria-hidden="true" class="v-icon material-icons theme--light">check</i>' : '<i aria-hidden="true" class="v-icon material-icons theme--light">account_circle</i>',
                'customStep3': isStepComplete ? '<i aria-hidden="true" class="v-icon material-icons theme--light">check</i>' : '<i aria-hidden="true" class="v-icon material-icons-outlined theme--light">check</i>'
            };

            const step = document.getElementsByClassName(classStep);
            if (step[0]) {
                // @ts-ignore
                step[0].childNodes[0].innerHTML = iconMap[classStep];
            }
        },
        loadInfoCompany(){
            if(this.$data.data){
                API.getEncryptedCompany(this.$data.data.rut_empresa, this.$data.data_enviar.token).
                then((response) => {
                    this.$data.empresa = this.$data.data_enviar.empresa =  response.data.data.empresa;
                    this.$data.data_enviar.usuario_id = response.data.data.usuario_id;
                    
                    // this.$data.form.rut = this.$data.empresa.rut;
                    this.$data.canShow = true;
                  }).catch(() => {
                    //token expirado
                    this.$data.canShow = true;
                    this.$data.isTokenExpired = true;
                })
            }
        },
        isLoginValid(){
          if(!this.$route.query.rut && !this.$route.query.token){
              //ver como arreglar esto
              this.$data.canShow = true;
              this.$data.isTokenExpired = true;
          }
          if(this.$store.state.user != null){
              this.$store.commit("logout");
              this.$store.commit('setBusinessSelected',null)
          }
        },
        scrollToCurrentStep() {
          this.$nextTick(() => {
            window.scrollTo(0, 0);
          });
        },

    },
    
    components: {
              ShowLoading,
              Step1,
              Step2,
              Step3
          },
  })
  export default class Myinfo extends Vue {}
  